var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { AvailableTooltip } from '../../../../components/other/AvailableTooltip';
let MenubarProgressGrade = class MenubarProgressGrade extends React.PureComponent {
    render() {
        const { app } = this.props;
        if (!app.user.userStore.showGrade)
            return null;
        return (React.createElement("div", { style: { fontSize: 13, textAlign: 'center', lineHeight: 0, marginTop: '-3px' } },
            React.createElement("span", null, "Note\u00A0"),
            React.createElement(AvailableTooltip, { placement: "bottom", title: `Note der letzten ${app.appGrade.numberOfAnswersGradeIsBasedOn} Antworten` },
                React.createElement("span", { className: "menu_grade" }, app.appGrade.currentGradeString))));
    }
};
MenubarProgressGrade = __decorate([
    observer
], MenubarProgressGrade);
export { MenubarProgressGrade };
